export const theme = {
  colors: {
    // Primary blues from the Pip Bros logo
    primary: '#1e3a8a',
    primaryLight: '#3b82f6',
    primaryDark: '#0b1e4f',

    // Secondary - refined slate palette
    secondary: '#475569',
    secondaryLight: '#94a3b8',
    secondaryDark: '#334155',

    // Accent
    accent: '#e0ecff',
    accentDark: '#93c5fd',

    // Surfaces
    background: '#ffffff',
    backgroundAlt: '#f6f8fc',
    surface: '#ffffff',
    surfaceMuted: '#eef2f8',

    // Dark surfaces - for sophisticated sections (hero, footer)
    surfaceDark: '#0b1227',
    surfaceDarker: '#070b1a',

    // Text
    text: '#0b1227',
    textLight: '#475569',
    textMuted: '#64748b',
    textOnDark: '#e6eaf2',
    textOnDarkMuted: '#9aa6c1',

    // Borders
    border: '#dbe2ec',
    borderLight: '#eef2f8',
    borderDark: 'rgba(255, 255, 255, 0.08)',

    // Status
    success: '#10b981',
    error: '#dc2626',
    warning: '#f59e0b',
  },

  fonts: {
    primary: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif",
    heading: "'Space Grotesk', 'Inter', sans-serif",
    mono: "'JetBrains Mono', 'SF Mono', Menlo, monospace",
  },

  spacing: {
    xs: '0.5rem',
    sm: '1rem',
    md: '1.5rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '5rem',
  },

  borderRadius: {
    sm: '0.375rem',
    md: '0.5rem',
    lg: '0.75rem',
    xl: '1rem',
    xxl: '1.5rem',
    full: '9999px',
  },

  shadows: {
    sm: '0 1px 2px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.04)',
    md: '0 4px 12px rgba(15, 23, 42, 0.08)',
    lg: '0 14px 32px rgba(15, 23, 42, 0.10)',
    xl: '0 24px 48px rgba(15, 23, 42, 0.16)',
    glow: '0 8px 32px rgba(59, 130, 246, 0.25)',
  },

  transitions: {
    fast: '150ms cubic-bezier(0.4, 0, 0.2, 1)',
    normal: '220ms cubic-bezier(0.4, 0, 0.2, 1)',
    slow: '320ms cubic-bezier(0.4, 0, 0.2, 1)',
  },

  breakpoints: {
    mobile: '480px',
    tablet: '768px',
    desktop: '1024px',
    wide: '1400px',
  },
};
